import React from "react";
import Sidebar from "../components/sidebar";
import Header from "../components/Header";
import AddLiveChannel from "../components/Live/AddLiveChannel";
  
const AddLiveChannelScreen = () => {
  return (
    <>
      <Sidebar />
      <main className="main-wrap">
        <Header />
        <AddLiveChannel />
      </main>
    </>
  );
};

export default AddLiveChannelScreen;
